/**
 * Huisstijl van een klant. Naam en kleur komen altijd uit de API (`brandName`
 * en `brandColor` op de klantregel, `/api/invoice-templates` in het formulier);
 * alleen de vaste volgorde van de drie merken hoort in de frontend thuis.
 */
export const BRAND_ORDER: readonly string[] = ['gentle_innovations', 'configurewise', 'innovanto']

export function brandRank(code: string): number {
  const index = BRAND_ORDER.indexOf(code)
  return index === -1 ? BRAND_ORDER.length : index
}
